<skychute-bar-loader></skychute-bar-loader>
@if (isLoading) {
  <skychute-logo-loader></skychute-logo-loader>
}
<router-outlet></router-outlet>
